import api from '../../api/http-common'

const getSupport = () =>
  api.post('/support/get-data')

const SupportService = {
  getSupport
};

export default SupportService;